import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import SmartLinkPage from "./SmartLinkPage";

function RedirectToAppropriatePage() {
  const location = useLocation();

  useEffect(() => {
    const redirects = {
      "prdgm.online": "https://paradigm-music.ru",
      "mtrk.live": "https://metrikamusic.com",
      "mtrk.click": "https://metrikamusic.com",
    };

    const hostname = window.location.hostname.replace(/^www\./, '');
    const pathname = location.pathname;

    if (pathname === "/" && redirects[hostname]) {
      window.location.replace(redirects[hostname]);
    }
  }, [location]);

  return null;
}

export default function App() {
  return (
    <Router>
      <RedirectToAppropriatePage />

      <Routes>
        <Route path="/:slug" element={<SmartLinkPage />} />
      </Routes>
    </Router>
  );
}
